module.exports = __webpack_public_path__ + "img/7.2377f1ba.png";